import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=47a97cb6&scoped=true&"
import script from "./MyCarousel.vue?vue&type=script&lang=js&"
export * from "./MyCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MyCarousel.vue?vue&type=style&index=0&id=47a97cb6&prod&lang=scss&scoped=true&"
import style1 from "./MyCarousel.vue?vue&type=style&index=1&id=47a97cb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a97cb6",
  null
  
)

export default component.exports